module.exports = __webpack_public_path__ + "img/5.2-数据孤岛.9c4a3c51.png";